var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');

var About = createReactClass({
    componentDidMount: function(){
        var $behindTheScenes = $('#behind-the-scenes');
        var $panes = $behindTheScenes.find('> .pane');
        var $navLis = $behindTheScenes.find('nav li');
        var $navSelect = $behindTheScenes.find('nav select');
        var $currentTitle = $behindTheScenes.find('.current-title');

        function updatePaneRelated(idSelectorOfTarget){
            // update nav lis
            $navLis.removeClass('is-active');
            $navLis.find('a[href="' + idSelectorOfTarget + '"]').parent().addClass('is-active');

            // update panes
            $panes.removeClass('is-active');
            $(idSelectorOfTarget).addClass('is-active');

            // update nav select
            $currentTitle.text($navSelect.find('option[value="' + idSelectorOfTarget + '"]').text());
            $navSelect.val(idSelectorOfTarget);
        }

        $('#behind-the-scenes-header nav li').click(function(e){
            e.preventDefault();
            updatePaneRelated($(this).find('a').attr('href'));
        });

        $navSelect.change(function(){
            updatePaneRelated($navSelect.val());
        });
    },

  render: function(){
    return (
        <div className="content">
            <Helmet
                title="About MyGiHealth &amp; My Total Health | mHealth Apps | Best Medical Apps"
                titleTemplate = "%s"
                meta={[
                    {"property": "description", "content": "In developing mHealth apps like MyGiHealth, My Total Health strives to provide the best medical apps for consumers and healthcare professionals."}
                ]}
            />
            <div className="content-header-wrapper">
                <div className="content-header row column">
                    <h1>About Us</h1>
                </div>
            </div>
            <div id="intro">
                <div className="intro-header">
                    <div className="row column">
                        <div className="medium-10 medium-centered column">
                            <h2>About MyGiHealth</h2>
                            <p>My Total Health was founded to enable patients to monitor, manage, and understand their symptoms for a range of conditions. MyGiHealth is the first of a pipeline of novel health applications created by the team.</p>
                        </div>
                    </div>
                </div>
                <div className="intro-body">
                    <div className="personal-use-option-wrapper use-option-wrapper row large-collapse">
                        <div className="bg-wrapper large-6 large-push-6 column">
                            <div className="bg"></div>
                        </div>
                        <div className="large-6 large-pull-6 column">
                            <div className="personal-use-option use-option">
                                <h3>Personal Use<span className="hide-for-large">-With Your Mobile Device</span></h3>
                                <p className="description">Use our academically researched and validated tools to gain control over your symptoms. Assess, track, and compare your symptoms to benchmarks, and learn more about them from an Education Prescription&copy;.</p>
                                <p className="show-for-large">
                                    <a className="download-app" href="http://get.mygihealth.io/downloadtheapp">
        								<img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/app-store-badge.png" alt="Download on the App Store" id="app-store-badge" />
        							</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="clinical-use-option-wrapper use-option-wrapper row large-collapse">
                        <div className="bg-wrapper large-6 column">
                            <div className="bg"></div>
                        </div>
                        <div className="large-6 column">
                            <div className="clinical-use-option use-option">
                                <h3>Clinical Use<span className="hide-for-large">-Connecting Healthcare Professionals To Patients</span></h3>
                                <p className="description">Working with experts in patient communication and computing technology, doctors at Cedars-Sinai, the University of Michigan and UCLA have re-engineered the role of technology in clinical practice.</p>
                            </div>
                        </div>
                    </div>
                    <div className="points row">
                        <div className="medium-6 column">
                            <div className="challenge-point point">
                                <p><strong>Addressing Challenges</strong></p>
                                <p>We are committed to working with top tier academic institutions to conduct novel research that leads to measurable improvements in patient outcomes. Our relationships today include University of California Los Angeles, University of Michigan, and Cedars-Sinai Medical Center.</p>
                            </div>
                        </div>
                        <div className="medium-6 column">
                            <div className="individual-point point">
                                <p><strong>Enabling Individuals</strong></p>
                                <p>We believe that by providing the right tools and tailored education, people can dramatically improve the management of their own symptoms, enhance the relationship with their healthcare provider, and influence health outcomes.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="behind-the-scenes">
                <div className="row column">
                    <div id="behind-the-scenes-header">
                        <h2>Behind the Scenes</h2>
                        <nav>
                            <ul className="no-bullet">
                                <li className="is-active"><a href="#doctors">Doctors</a></li>
                                <li><a href="#team">The Team</a></li>
                                <li><a href="#research-teams">Research</a></li>
                            </ul>
                            <div className="show-for-small-only">
                                <span className="current-title">Our Doctors</span>
                                <select onChange={this.toggle}>
                                    <option value="#doctors">Our Doctors</option>
                                    <option value="#team">The Team</option>
                                    <option value="#research-teams">Research Teams</option>
                                </select>
                                <span className="ion-ios-arrow-down"></span>
                            </div>
                        </nav>
                    </div>
                </div>
                <div id="doctors" className="pane is-active">
                    <div className="row show-for-large">
                        <div className="column">
                            <h3>Our Doctors</h3>
                            <p>Dr. Brennan Spiegel and Dr. William D. Chey are internationally recognized experts in the field of digestive diseases and nutrition. They are accomplished physicians and scientists who hold leadership positions in national and international organizations. Between both doctors, they have published over 300 articles in the peer-reviewed literature, including over 10 articles in support of MyGiHealth. Their research at Cedars-Sinai Medical Center, the University of Michigan, and UCLA led to the development of MyGiHealth.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-6 column">
                            <div className="member">
                                <div className="member-photo">
                                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/Spiegel_head-and-shoulders-2-520x346.jpeg" alt="" />
                                </div>
                                <div className="member-text">
                                    <p className="member-name">Dr. Brennan Spiegel</p>
                                    <p className="member-meta">CO FOUNDER/CO CHIEF MEDICAL OFFICER</p>
                                    <p className="member-desc show-for-large">Dr. Brennan Spiegel MD, MSHS, RFF, FACG, AGAF. UCLA, is a Professor of Medicine, Public Health, and Digestive Diseases, runs UCLA’s Public Health curriculum on big data science, digital health science, and health analytics, and is also Director of Health Services Research for Cedars-Sinai Health System and Co-Editor-in-Chief of the American Journal of Gastroenterology, the leading clinical GI journal in North America. Forbes magazine recently covered Dr. Spiegel’s work in digital health, describing it as on the ``bleeding edge of technology.``</p>
                                    <p className="social-icons">
                                        <a className="ion-social-twitter" href="https://twitter.com/brennanspiegel"><span className="show-for-sr">Twitter</span></a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="medium-6 column end">
                            <div className="member">
                                <div className="member-photo">
                                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/IMG_1861-e14284393174291_new2-520x346.jpg" alt="" />
                                </div>
                                <div className="member-text">
                                    <p className="member-name">Dr. William Chey</p>
                                    <p className="member-meta">CO FOUNDER/CO CHIEF MEDICAL OFFICER</p>
                                    <p className="member-desc show-for-large">Dr. William D. Chey MD, FACP, RFF, FACG, AGAF is a Professor of Medicine, Director of the GI Physiology Lab, Director of the Digestive Diseases Center for Nutrition & Lifestyle, and Co-Director of the Michigan Bowel Control Program at the University of Michigan and former Co-Editor in Chief of the American College of Gastroenterology. TedEd recently featured Dr. Chey’s work in digestive health.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="team" className="pane">
                    <div className="row show-for-large">
                        <div className="column">
                            <h3>The Team</h3>
                            <p>We are a group of technology entrepreneurs and highly respected gastroenterologists that have come together over a shared vision to improve the lives of millions of people.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-6 column">
                            <div className="member">
                                <div className="member-photo">
                                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/IMG_1861-e14284393174291_new3-520x346.jpg" alt="" />
                                </div>
                                <div className="member-text">
                                    <p className="member-name">Duncan McLaren</p>
                                    <p className="member-meta">CEO</p>
                                    <p className="member-desc show-for-large">Duncan is a serial entrepreneur who co-founded Soapbox Mobile, a B2B mobile marketing company, where he was responsible for all business development initiatives. It was sold to Single Touch Systems (OTC: SITO) in 2007. More recently, he co-founded a photo-based mobile social network, Butter, which continues to grow strongly.</p>
                                </div>
                            </div>
                        </div>
                        <div className="medium-6 column">
                            <div className="member">
                                <div className="member-photo">
                                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/chris-action-520x346.png" alt="" />
                                </div>
                                <div className="member-text">
                                    <p className="member-name">Chris Smith</p>
                                    <p className="member-meta">CTO</p>
                                    <p className="member-desc show-for-large">Chris is an expert in a variety of open source technologies and has a long track record of successfully planning, architecting, and implementing various system frameworks. Previously he spent eight years at Active Networks, where he built and led a team of 40 developers through to its initial public offering.</p>
                                    <p className="social-icons">
                                        <a className="ion-social-twitter" href="https://twitter.com/cedwardsmith"><span className="show-for-sr">Twitter</span></a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-6 column">
                            <div className="member">
                                <div className="member-photo">
                                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/will.jpg" alt="" />
                                </div>
                                <div className="member-text">
                                    <p className="member-name">Will Taylor</p>
                                    <p className="member-meta">UI/UX DESIGNER</p>
                                    <p className="member-desc show-for-large">Will Taylor is a versatile UI/UX design consultant with nearly a decade of experience. He has worked in various markets specializing in creating usable interfaces for web, mobile, and desktop platforms. <br /><br />Along with an extensive creative background, Will adds an understanding for platform specific design principles and front-end knowledge, as well as performing competitive/market analysis to gather information that best suits the specified target market. He believes that understanding users is key in developing a sustainable and relatable solution.</p>
                                </div>
                            </div>
                        </div>
                        <div className="medium-6 column">
                            <div className="member">
                                <div className="member-photo">
                                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/dan.jpg" alt="" />
                                </div>
                                <div className="member-text">
                                    <p className="member-name">Dan Flanegan</p>
                                    <p className="member-meta">HEAD OF PRODUCT</p>
                                    <p className="member-desc show-for-large">Dan Flanegan is an entrepreneur with over 20 years experience in consumer internet and mobile product design, development and growth. He co-founded Soapbox Mobile a B2B brand marketing platform and Butter a B2C consumer mobile application. Dan also advises companies on product, growth and fundraising strategies with a focus on digital health, AR/VR and blockchain technologies.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-6 column">
                            <div className="member">
                                <div className="member-photo">
                                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/sharma.jpg" alt="" />
                                </div>
                                <div className="member-text">
                                    <p className="member-name">Dr Rajiv Sharma</p>
                                    <p className="member-meta">Advisor</p>
                                    <p className="member-desc show-for-large">Dr Rajiv Sharma aka "Dr Raj" was born in Ludhiana, India. He received his Internal Medicine training at Loma Linda University in Southern California before moving to Rochester, NY to pursue his Gastroenterology Fellowship under the mentorship of Dr Richard D Farmer, former Chief of GI, Cleveland Clinic and world renowned for his work on Inflammatory Bowel Disease. He started in own Gastroenterology practice, Digestive Health Associates, in Terre Haute, In, which is growing rapidly. He is planning to open another 3 clinics this coming year. He is the author of “Pursuit of Gut Happiness: A Guide to Using Probiotics to Achieve Optimal Health”, and created a line of probiotic supplements to support the business: <a href="https://drguthappiness.com" rel="nofollow">https://drguthappiness.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="research-teams" className="pane">
                    <div className="row show-for-large">
                        <div className="column">
                            <h3>Research Teams</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-6 column">
                            <div className="member">
                                <div className="member-photo">
                                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/Core-Team-2013-292-21-520x346.jpg" alt="" />
                                </div>
                                <div className="member-text">
                                    <p className="member-name">CS-CORE</p>
                                    <p className="member-meta">DATA SCIENTISTS</p>
                                    <p className="member-desc show-for-large">MTH is a data company, and is fortunate to work with a nationally recognized group of academic data scientists at the Cedars-Sinai Center for Outcomes Research and Education. Under the Direction of Dr. Spiegel CS-CORE is a group of academicians that supports high quality research efforts using a modern health services and health analytic methodologies. Members of the Center have published extensively in top-tier medical Journals such as the Annals of Internal Medicine, JAMA Medicine, American Journal of Gastroenterology, and others.</p>
                                </div>
                            </div>
                        </div>
                        <div className="medium-6 column end">
                            <div className="member">
                                <div className="member-photo">
                                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/staff1-520x346.jpg" alt="" />
                                </div>
                                <div className="member-text">
                                    <p className="member-name">CHCR</p>
                                    <p className="member-meta">UNIVERSITY OF MICHIGAN CENTER FOR HEALTH COMMUNICATIONS RESEARCH</p>
                                    <p className="member-desc show-for-large">Designated a Center of Excellence in Cancer Communications Research by the National Cancer Institute. Conducting research in individually tailored health communications since 1995. Developed over 100 tailored research interventions covering an extremely broad variety of topics, audiences, settings, and technologies.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="office" className="show-for-medium">
                <div className="row">
                    <div className="medium-6 column">
                        <div className="interested">
                            <p>Are you interested in working or<br /> partnering with MyTotalHealth?</p>
                            <p><a className="button" href="mailto:inquiries@mytotalhealthinc.com">Email Us</a></p>
                        </div>
                    </div>
                    <div className="medium-6 column">
                        <div className="office-box">
                            <h2>Our Offices</h2>
                            <p>Pacific Theatres Building <br />116 North Robertson Blvd, 4th Floor <br />Los Angeles, CA 90048</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
});

module.exports = About;



// WEBPACK FOOTER //
// ./src/common/routes/about/components/about.jsx